const PhaseUsageReport = {

	visual: {
		icon: "va-icon fa fa-area-chart",
		title: "Phase usage report",
		desc: "Analysis of Phases used in the twitter eco system."
	},

	binding: [
		{"phrase_useage_text": "string","label":"Phrase"},
		{"phrase_useage_limit": "number", "label":"Phrase Limit"},
		{"status_created_at_from": "date","label":"Status ('posted') created from"},
		{"status_created_at_to": "date","label":"Status ('posted') created to"}
	],

	query:`
		MATCH 
			(s:Status)-[p:POSTED_BY | :RETWEETED_BY]->(a:Account) 
		WHERE 
			date(s.created_at) >= date(':status_created_at_from') AND date(s.created_at) <= date(':status_created_at_to')
		AND
			s.text =~ '.*:phrase_useage_text.*'
		RETURN 
			a, p, s 
		LIMIT 
			:phrase_useage_limit
	`,

	config:{
		console_debug:false,
		labels: {
			"Account": {
				"caption": "screen_name"
			},
			"Status": {
				"caption": false
			}
		}
	}
	
}

export default PhaseUsageReport;
